{
  "name": "attendance-management",
  "version": "25.8.25",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 0.0.0.0 --port 4200",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint AttendanceManagement",
    "e2e": "ng e2e",
    "analyze": "webpack-bundle-analyzer dist/AttendanceManagement/browser/stats.json"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.12",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/fire": "^17.0.1",
    "@angular/forms": "^17.3.12",
    "@angular/material": "^17.3.10",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/platform-server": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@angular/service-worker": "^17.3.12",
    "@types/encoding-japanese": "^1.0.17",
    "@types/mocha": "^8.2.1",
    "@types/pdfmake": "^0.1.19",
    "core-js": "^3.9.1",
    "csvtojson": "^2.0.8",
    "encoding-japanese": "^1.0.29",
    "file-saver": "^2.0.5",
    "html-to-pdfmake": "^2.3.4",
    "firebase": "^10.12.4",
    "jszip": "^3.6.0",
    "luxon": "^3.7.2",
    "ngx-indexed-db": "^10.0.0",
    "nodemailer": "^6.5.0",
    "pdfmake": "^0.1.68",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^8.3.2",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.17",
    "@angular-eslint/builder": "^17.5.3",
    "@angular-eslint/eslint-plugin": "^17.5.3",
    "@angular-eslint/eslint-plugin-template": "^17.5.3",
    "@angular-eslint/schematics": "^17.5.3",
    "@angular-eslint/template-parser": "^17.5.3",
    "@angular/cli": "^17.3.17",
    "@angular/compiler-cli": "^17.3.12",
    "@angular/language-service": "^17.3.12",
    "@types/jasmine": "^3.6.4",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^14.14.31",
    "@types/uuid": "^8.3.4",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "eslint": "^8.57.0",
    "firebase-admin": "^9.5.0",
    "firebase-functions": "^3.13.2",
    "jasmine-core": "^3.6.0",
    "jasmine-spec-reporter": "~4.2.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.1.0",
    "karma-coverage-istanbul-reporter": "^2.1.1",
    "karma-jasmine": "^2.0.1",
    "karma-jasmine-html-reporter": "^1.5.4",
    "protractor": "^7.0.0",
    "ts-node": "^9.1.1",
    "typescript": "5.4.5",
    "webpack-bundle-analyzer": "^4.4.0"
  }
}
